export default {
  // 表格列
  'table.match.matchNo': '比赛编号',
  'table.match.brandName': '品牌名称',
  'table.match.storeName': '门店名称',
  'table.match.tableNo': '球桌编号',
  'table.match.deviceName': '设备名称',
  'table.match.matchType': '比赛类型',
  'table.match.playerCount': '参赛人数',
  'table.match.status': '比赛状态',
  'table.match.winnerPlayerName': '获胜者',
  'table.match.startedAt': '开始时间',
  'table.match.finishedAt': '结束时间',
  'table.match.createdAt': '创建时间',
  'table.match.frameRule': '局规则',
  'table.match.currentProgress': '当前进度',
  'table.match.frameNo': '场次',
  'table.match.gameNo': '局数',
  'table.common.actions': '操作',

  // 比赛类型
  'matchType.SNOOKER': '斯诺克',
  'matchType.NINE_BALL': '九球',
  'matchType.EIGHT_BALL': '中八',

  // 比赛状态
  'matchStatus.WAITING': '等待开始',
  'matchStatus.PLAYING': '进行中',
  'matchStatus.FINISHED': '已结束',
  'matchStatus.CANCELLED': '已取消',

  // 获胜方式
  'winMethod.NORMAL': '正常获胜',
  'winMethod.NINE_BALL': '打进9号球',
  'winMethod.EIGHT_BALL': '打进8号球',
  'winMethod.FOUL': '犯规获胜',
  'winMethod.FORFEIT': '对方弃权',
  'winMethod.TIMEOUT': '超时获胜',
  'winMethod.SURRENDER': '对方弃权',

  // 表单
  'form.match.brandPlaceholder': '请选择品牌',
  'form.match.storePlaceholder': '请选择门店',

  // 错误提示
  'error.match.loadListFailed': '加载比赛列表出错',
  'error.match.loadDetailFailed': '加载比赛详情失败',
  'error.match.notFound': '比赛不存在或已被删除',

  // 详情页 - 页面标题
  'pages.match.detail.title': '比赛详情',
  'pages.match.detail.basicInfo': '基本信息',
  'pages.match.detail.playerStats': '参赛球员统计',
  'pages.match.detail.frameData': '每场每局数据',
  'pages.match.detail.playerNo': '编号',
  'pages.match.detail.wonFrames': '胜场',
  'pages.match.detail.wonGames': '胜局',
  'pages.match.detail.totalScore': '总得分',
  'pages.match.detail.highestScore': '最高分',
  'pages.match.detail.frameNo': '第 {0} 场',
  'pages.match.detail.currentGameNo': '第 {0} 局',
  'pages.match.detail.winner': '获胜者',
  'pages.match.detail.noData': '暂无数据',
  'pages.match.detail.duration': '时长',
  'pages.match.detail.startedAt': '开始时间',
  'pages.match.detail.finishedAt': '结束时间',
  'pages.match.detail.joinMethod.SCAN': '扫码加入',
  'pages.match.detail.joinMethod.ANONYMOUS': '匿名加入',

  // 详情页 - 技术统计
  'pages.match.detail.technicalStats': '技术统计数据',
  'pages.match.detail.basicStats': '基础统计',
  'pages.match.detail.successRateStats': '成功率统计',
  'pages.match.detail.snookerStats': '斯诺克专属统计',

  // 技术统计字段
  'pages.match.detail.stats.totalPoints': '总得分',
  'pages.match.detail.stats.cueHighScore': '单杆最高分',
  'pages.match.detail.stats.raceScore': '赢得局数',
  'pages.match.detail.stats.ballCount': '进球数',
  'pages.match.detail.stats.cueCount': '击球次数',
  'pages.match.detail.stats.foulCount': '犯规次数',
  'pages.match.detail.stats.errorCount': '失误次数',
  'pages.match.detail.stats.avgShotTime': '平均击球时间',
  'pages.match.detail.stats.avgMistakesPerFrame': '平均每局失误数',
  'pages.match.detail.stats.tableTopHour': '台面时长',
  'pages.match.detail.stats.seconds': '秒',
  'pages.match.detail.stats.scoringShots': '进球击球数',
  'pages.match.detail.stats.attemptsShots': '尝试击球数',
  'pages.match.detail.stats.potSuccess': '进球成功率',
  'pages.match.detail.stats.longPotScoringShots': '远台进球数',
  'pages.match.detail.stats.longPotAttemptsShots': '远台尝试数',
  'pages.match.detail.stats.longPotSuccess': '远台成功率',
  'pages.match.detail.stats.restPots': '架杆进球数',
  'pages.match.detail.stats.restAttempts': '架杆尝试数',
  'pages.match.detail.stats.restPotSuccess': '架杆成功率',
  'pages.match.detail.stats.penaltyPoints': '罚分',
  'pages.match.detail.stats.breakSequence': '破百次数',
  'pages.match.detail.stats.break50Plus': '单杆50+次数',
  'pages.match.detail.stats.break30Plus': '单杆30+次数',
  'pages.match.detail.stats.redPots': '红球进球数',
  'pages.match.detail.stats.redAttempts': '红球尝试数',
  'pages.match.detail.stats.redPotSuccess': '红球成功率',
  'pages.match.detail.stats.colorPots': '彩球进球数',
  'pages.match.detail.stats.colorAttempts': '彩球尝试数',
  'pages.match.detail.stats.colorPotSuccess': '彩球成功率',
  'pages.match.detail.stats.makeSnookerCount': '做斯诺克次数',
  'pages.match.detail.stats.resolveFailCount': '解球失败次数',
  'pages.match.detail.stats.safetySuccess': '安全球成功率',

  // 详情页 - 表格列
  'table.matchDetail.gameNo': '局号',
  'table.matchDetail.score': '得分',
  'table.matchDetail.winner': '获胜者',
  'table.matchDetail.winMethod': '获胜方式',
  'table.matchDetail.duration': '时长',
  'table.matchDetail.startedAt': '开始时间',
  'table.matchDetail.finishedAt': '结束时间',

  // 通用
  'common.back': '返回',
  'common.viewDetail': '查看详情',
  'table.common.action': '操作',
};
